import { AppBar, AppBarSection, AppBarSpacer } from '@progress/kendo-react-layout'
import React, {useCallback, useEffect, useState} from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import './PublicHeader.scss';
import { Button, DropDownButton } from "@progress/kendo-react-buttons";
import SubscriptionLogoutButton from '../../../components/stateless/subscriptionLogoutButton/SubscriptionLogoutButton';
import SubscriptionLoginButton from '../../../components/stateless/subscriptionLoginButton/SubscriptionLoginButton';
import {SubscriptionAccountButton} from "../../../components/stateless/subscriptionAccountButton/SubscriptionAccountButton";
import AdminManagementButton from "../../../components/stateless/adminManagementButton/AdminManagementButton";
import SignOutButton from "../../../components/stateless/signOutButton/SignOutButton";
import SignInButton from "../../../components/stateless/signInButton/SignInButton";
import { usePublicHeaderController } from './PublicHeaderController';
import Authorized from '../../../components/stateful/authorized/Authorized';
import { Roles } from '../../../utilities/enums/Roles';
import LoginContainer from "../../../pages/public/authentication/subscriptions/loginContainer/LoginContainer";
import CustomDialog from "../../../components/stateless/dialog/CustomDialog";

const PublicHeader = (props: any) => {
    const {
        isAdminAuthenticated,
        isDBAuthenticated,
        accounts,
    } = usePublicHeaderController();
    const navigate = useNavigate();
    const [open, setOpen] = useState<boolean>(props.resetPassword || props.activateAccount);
    const [passwordReset, setPasswordReset] = useState<boolean>(props.resetPassword);
    const [activateAccount] = useState<boolean>(props.activateAccount);
    const [userName, setUserName] = useState<string>("");
    const subscriptionUser = localStorage.getItem('subscriptionUser');

    const passwordIsSet = useCallback(() => {setPasswordReset(false);}, [],);

    const passwordSteps = passwordReset ? 1 : 0;

    const toggleDialog = () => {
        // navigate("/");
        open ? setOpen(false) : setOpen(true);
    };

    useEffect(() => {
        if(isAdminAuthenticated && isDBAuthenticated){
            if(accounts[0]){
                setUserName(accounts[0].name ?? "");
            }else{
                setUserName("");
            }
        }else if(subscriptionUser) {
            setUserName(subscriptionUser);
        }else {
            setUserName("Login Options");
        }
    }, [accounts, isAdminAuthenticated, isDBAuthenticated, subscriptionUser]);

    // TODO Theres a bit of lag for this to load.
    //  Thinking there is a better way to get this running without processing after the user has seen it
    //  Thinking it's setting the state instead of a method, but what would be the best way to rerun the method
    const renderItems = () => {
        let items = [];

        if(subscriptionUser){
            items.push(<SubscriptionLogoutButton />);
            items.push(<SubscriptionAccountButton />);
        }else{
            items.push(<SubscriptionLoginButton toggleDialog={toggleDialog} />);
        }

        if(isAdminAuthenticated && isDBAuthenticated){
            items.push(<Authorized roles={[Roles.Admin]}><AdminManagementButton /></Authorized>);
            items.push(<Button className={"adminButton"} fillMode={"link"} onClick={() => navigate("/state/work-queue")}><span className="k-icon k-i-link">&nbsp;</span>State Portal</Button>);
            items.push(<SignOutButton />);
        }else{
            items.push(<SignInButton />);
        }

        return items;
    };

    return (
        <React.Fragment>
            <AppBar style={{paddingLeft: '32px'}}>                

                <AppBarSection className="appbar-title">
                    <div className="appbar-title">
                        <span className="k-icon k-i-arrow-chevron-left"></span>
                        <a href="https://www.sos.nebraska.gov">SOS.NEBRASKA.GOV</a>
                    </div>
                </AppBarSection>

                <NavLink className="nav-link-subscribe nav-link-home" to='/'>
                    <span className="k-icon k-i-home">&nbsp;</span>Rules Home Page
                </NavLink>

                <NavLink className="nav-link-subscribe nav-link-about" to='/about'>
                    <span className="k-icon k-i-file-header">&nbsp;</span>About Rules & Regulations
                </NavLink>

                <AppBarSection className='appbar-auth-section'>
                    <AppBarSection className="appbar-items">
                        <DropDownButton text={
                            <span className="nav-link-subscribe">
                                <><span className="k-icon k-i-gear">&nbsp;</span>{userName}</>
                            </span>} className="appbar-items"
                            items={renderItems()}
                            fillMode={"flat"}
                        />
                    </AppBarSection>
                </AppBarSection>

                <CustomDialog open={open} hideButtons toggleDialog={toggleDialog} title="Login to your Subscription Account" size="medium">
                    <LoginContainer dialogToggle={toggleDialog} tabSelect={passwordSteps} resetPassword={passwordReset}
                                    passwordHasBeenSet={passwordIsSet} activateAccount={activateAccount}/>
                </CustomDialog>

                <AppBarSpacer style={{ width: 32 }} />
            </AppBar>
        </React.Fragment>
    )
}

export default PublicHeader